import Vue from 'vue'
import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'

import 'vue-toastr/src/vue-toastr.scss'

import axios from 'axios'
import VueAxios from 'vue-axios'

import VueAuth from '@websanova/vue-auth'
import VueAuthBearer from '@websanova/vue-auth/drivers/auth/bearer'
import VueAuthHttp from '@websanova/vue-auth/drivers/http/axios.1.x'
import VueAuthRouter from '@websanova/vue-auth/drivers/router/vue-router.2.x'

import App from './App.vue'
import router from './router'
import store from './store'

Vue.use(VueRouter)
Vue.use(VueAxios, axios)
Vue.use(BootstrapVue)

console.log(window.location.host)

if (window.location.host === 'localhost:8080') {
    Vue.axios.defaults.baseURL = 'http://178.90.136.190:8000/api/'
} else {
    Vue.axios.defaults.baseURL = 'https://api.profi-bank.org/api/'
}

Vue.router = router

Vue.use(VueAuth, {
    auth: VueAuthBearer,
    http: VueAuthHttp,
    router: VueAuthRouter,
    authRedirect: {
        name: 'AuthLogin'
    },
    loginData: {
        url: 'auth/login'
    },
    logoutData: {
        url: 'auth/logout'
    },
    fetchData: {
        url: 'auth/user'
    },
    refreshData: {
        url: 'auth/refresh'
    }
})

Vue.axios.interceptors.response.use(response => response, error => {
    if (error.response.status === 401) {
        let data = error.response.data
        if (data.hasOwnProperty('message') && (data.message !== 'Bad credentials')) {
            Vue.auth.logout()
        }
    }
    return Promise.reject(error)
})

const app = new Vue({
    template: '<App/>',
    router,
    store,
    components: {App}
})

app.$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js